import React from 'react';

import i18n from '@components/i18n/i18n';
import colors from '@theme/colors';
import { NotificationWrap } from './Notification.styles.js';
import content from './Notification.json';

const Notification = ({ type, message }) => {
  const language = i18n.language;
  const dir = i18n.dir();
  const config = {
    success: {
      backgroundColor: colors['very-light-brown'],
      color: colors['charcoal'],
      typeText: content.success[language],
    },
    error: {
      backgroundColor: colors['very-light-brown'],
      color: colors['charcoal'],
      typeText: content.error[language],
    },
  }[type];

  return (
    <NotificationWrap
      backgroundColor={config.backgroundColor}
      color={config.color}
    >
      <strong>{config.typeText}</strong> {message}
    </NotificationWrap>
  );
};

export default Notification;
